import * as React from "react";
import { useGoopyPress } from "@/hooks/useGoopyPress";
import { cn } from "@/lib/utils";

/**
 * Drop-in replacement for <button> that adds tactile press animation.
 * No styling opinions — just goopy squish on press, stretch-snap on release.
 */
const Pressable = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    pressProfile?: "default" | "subtle" | "none";
  }
>(
  (
    {
      disabled,
      className,
      style,
      onPointerDown,
      onPointerUp,
      onPointerLeave,
      pressProfile = "default",
      ...props
    },
    ref
  ) => {
    const press = useGoopyPress({ disabled, profile: pressProfile });

    return (
      <button
        ref={ref}
        disabled={disabled}
        className={cn("cursor-pointer disabled:cursor-default", className)}
        style={{ ...press.style, ...style }}
        onPointerDown={(e) => {
          press.onPointerDown();
          onPointerDown?.(e);
        }}
        onPointerUp={(e) => {
          press.onPointerUp();
          onPointerUp?.(e);
        }}
        onPointerLeave={(e) => {
          press.onPointerLeave();
          onPointerLeave?.(e);
        }}
        {...props}
      />
    );
  }
);

Pressable.displayName = "Pressable";

export { Pressable };
